/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ChecklistChecklistidItems200,
  GetApiV1ChecklistChecklistidItems401,
  GetApiV1ChecklistChecklistidItems404,
  GetApiV1ChecklistChecklistidItems500,
  GetApiV1ChecklistChecklistidItemsPathParams,
  GetApiV1ChecklistChecklistidItemsQueryParams,
  GetApiV1ChecklistChecklistidItemsQueryResponse,
} from "../../types/checkListItensController/GetApiV1ChecklistChecklistidItems.ts";
import { checkListItemViewModelPaginatedResponseSchema } from "../checkListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1ChecklistChecklistidItemsPathParamsSchema = z.object({
  checkListId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsPathParams>;

export const getApiV1ChecklistChecklistidItemsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ChecklistChecklistidItems200Schema = z.lazy(
  () => checkListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ChecklistChecklistidItems200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ChecklistChecklistidItems401Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItems401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ChecklistChecklistidItems404Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItems404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ChecklistChecklistidItems500Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItems500>;

export const getApiV1ChecklistChecklistidItemsQueryResponseSchema = z.lazy(
  () => getApiV1ChecklistChecklistidItems200Schema,
) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsQueryResponse>;
